var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.3335H11.3333L15.3333 5.3335V13.3335C15.3333 14.0668 14.7333 14.6668 14 14.6668H6C5.26667 14.6668 4.66667 14.0668 4.66667 13.3335H14V6.00016H10.8152C10.7734 6.00016 10.7344 6.00016 10.6667 6.00016V2.66683H6V3.57575C5.78091 3.55822 5.55841 3.54924 5.33309 3.54924C5.10793 3.54924 4.8856 3.55821 4.66667 3.57571V2.66683C4.66667 1.9335 5.26667 1.3335 6 1.3335Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33316 4.82293C2.909 4.82293 0.838761 6.33076 0 8.45917C0.838761 10.5876 2.909 12.0954 5.33316 12.0954C7.75732 12.0954 9.82756 10.5876 10.6663 8.45917C9.82756 6.33076 7.75732 4.82293 5.33316 4.82293ZM5.33316 10.8833C3.99502 10.8833 2.909 9.79731 2.909 8.45917C2.909 7.12104 3.99502 6.03501 5.33316 6.03501C6.6713 6.03501 7.75732 7.12104 7.75732 8.45917C7.75732 9.79731 6.6713 10.8833 5.33316 10.8833ZM5.33316 7.00467C4.52834 7.00467 3.87866 7.65435 3.87866 8.45917C3.87866 9.264 4.52834 9.91367 5.33316 9.91367C6.13798 9.91367 6.78766 9.264 6.78766 8.45917C6.78766 7.65435 6.13798 7.00467 5.33316 7.00467Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.bd22d18311437d69a29f022dd46504eb.svg";
export { ForwardRef as ReactComponent };